import createIcon from '../../createIcon';

/**
 * @component @name MarkEmailUnread
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgOS45OFYxOUMyMiAyMC4xIDIxLjEgMjEgMjAgMjFINEMyLjkgMjEgMiAyMC4xIDIgMTlWN0MyIDUuOSAyLjkgNSA0IDVIMTQuMUMxNC4wNCA1LjMyIDE0IDUuNjYgMTQgNkMxNCA3LjQ4IDE0LjY1IDguNzkgMTUuNjcgOS43MUwxMiAxMkw0IDdWOUwxMiAxNEwxNy4zIDEwLjY4QzE3Ljg0IDEwLjg4IDE4LjQgMTEgMTkgMTFDMjAuMTMgMTEgMjEuMTYgMTAuNjEgMjIgOS45OFpNMTYgNkMxNiA3LjY2IDE3LjM0IDkgMTkgOUMyMC42NiA5IDIyIDcuNjYgMjIgNkMyMiA0LjM0IDIwLjY2IDMgMTkgM0MxNy4zNCAzIDE2IDQuMzQgMTYgNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MarkEmailUnread = createIcon('MarkEmailUnread', [
  [
    'path',
    {
      d: 'M22 9.98V19C22 20.1 21.1 21 20 21H4C2.9 21 2 20.1 2 19V7C2 5.9 2.9 5 4 5H14.1C14.04 5.32 14 5.66 14 6C14 7.48 14.65 8.79 15.67 9.71L12 12L4 7V9L12 14L17.3 10.68C17.84 10.88 18.4 11 19 11C20.13 11 21.16 10.61 22 9.98ZM16 6C16 7.66 17.34 9 19 9C20.66 9 22 7.66 22 6C22 4.34 20.66 3 19 3C17.34 3 16 4.34 16 6Z',
      key: 'h27uz9',
    },
  ],
]);

export default MarkEmailUnread;
